module.exports = __webpack_public_path__ + "static/media/discord.cfadad6f.png";